import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions';
import './VideoPlayer.scss';
import * as ConfigTypes from 'config/ConfigTypes';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import {
    faPlay, faVolumeUp, faPause, faVolumeMute
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getMediaUrl } from 'helpers/FileHelper';
import { getImgUrl } from "helpers/ImageHelper";
import { checkAndConvert } from 'helpers/SubtitleHelper';
import { getBaseName, pubPath, isHome } from 'helpers/AppHelper';

class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeTotal: 0,
            isMouseDown: false,
            uiTimeout: '',
            volumeWidth: ConfigTypes.VOLUME_WIDTH,
            isSubtitle: false,
            subSettingsDdDisplay: ConfigTypes.NONE,
            subLg: 'en',
            currentSpeed: '1',
            subShow: ConfigTypes.NONE,
            speedDdDisplay: ConfigTypes.NONE,
            speedRef: React.createRef(),
            subSettingsRef: React.createRef(),
            loadLater: ConfigTypes.LOAD_LATER
        }
    }

    onPlayKeyUp = (e) => {
        if (e.key === ConfigTypes.ENTER) this.togglePlayPause();
    }
    onMutedKeyUp = (e) => {
        if (e.key === ConfigTypes.ENTER) this.toggleMuted();
    }
    onFullScreenKeyUp = (e) => {
        if (e.key === ConfigTypes.ENTER) this.onFullScreen();
    }

    showUI = () => {
        if (this.state.uiTimeout) clearTimeout(this.state.uiTimeout);
        this.state.controls.classList.add('active');
        if (this.state.video && this.state.video.style) {
            this.state.video.style.cursor = 'default';
            let controlsHeight = this.state.controls.getBoundingClientRect().height;
            if (this.state.subElement && this.state.subElement.style) {
                this.state.subElement.style.bottom = controlsHeight + 'px';
            }
        }
    }

    hideUI = () => {
        if (this.state.uiTimeout) clearTimeout(this.state.uiTimeout);
        if (this.state.video.paused) return;
        let uiTimeout = setTimeout(() => {
            this.state.controls.classList.remove('active');
            this.state.subElement.style.bottom = '0px';

            setTimeout(() => this.state.video.style.cursor = ConfigTypes.NONE, 1000);
        }, ConfigTypes.UI_TIMEOUT);
        this.setState({ uiTimeout });
    }

    //AUTO AND LOOP BEGIN 
    loopLaneTrainer = () => {
        const { homeObj, trailerLane } = this.props.mediaObjects;
        if (homeObj) {
            if (!this.props.isAutoPlay || !this.props.isTrailer) {
                let obj;
                let subTrailer = this.props.getSubTrailer()
                if (subTrailer) {
                    obj = {
                        trailerPlaying: true, laneLooped: true,
                        homeObj: { ...homeObj, trailerStart: true }
                    }
                    obj.currentClip = subTrailer;
                    obj.homeObj.trailerObj = subTrailer;
                } else {
                    obj = {
                        currentLane: trailerLane, autoChanged: true,
                        laneDisabled: true, trailerPlaying: true,
                        homeObj: { ...homeObj, trailerStart: true }
                    }
                }
                this.props.updateMediaObjects(obj);
                if (!isHome()) this.props.router.navigate("/");
                this.initAll();
            }
        }
    }

    autoPlayAndLoop = () => {
        const { homeObj, currentTrailer, currentClip } = this.props.mediaObjects;
        const { isAutoPlay, isLoop, isTrailer } = this.props;
        this.deactivateMuted();
        if (isAutoPlay) {
            this.activateMuted()
            this.state.video.play();
            this.setState({ isPlaying: true });
            setTimeout(() => {
                if (ConfigTypes.WITH_SOUND) this.deactivateMuted();
                let trailerPlaying = isTrailer ? true : false;
                let obj = {
                    trailerPlaying, homeObj: { ...homeObj, trailerObj: currentTrailer },
                    currentClip: isTrailer ? currentTrailer : currentClip
                }
                let subTrailer = this.props.getSubTrailer()
                if (subTrailer) {
                    if (isTrailer) {
                        obj.currentClip = subTrailer;
                        obj.homeObj.trailerObj = subTrailer;
                    }
                }
                this.props.updateMediaObjects(obj);
            }, 100);
        }
        if (isLoop) this.state.video.loop = true;
        else this.state.video.loop = false;

    }
    //AUTO AND LOOP BEGIN 

    setVideoData = () => {
        if (this.state.video && this.state.video.readyState) {
            let timeTotal = 0;
            let seconds = Math.floor(this.state.video.duration % 60);
            let minutes = Math.floor(this.state.video.duration / 60);
            seconds = seconds >= 10 ? seconds : '0' + seconds;
            timeTotal = `${minutes}:${seconds}`;
            if (typeof (this.state.timeBar) == 'object') {
                this.state.timeBar.max = this.state.video.duration;
            }
            this.state.timeCounter.innerText = `0:00 / ${timeTotal}`;
            this.setState({ timeTotal: timeTotal });
            this.updateCurrentTime();
            this.setUpTracks({ isSubtitle: this.state.isSubtitle });
            this.autoPlayAndLoop();
        }
    }

    updateCurrentTime = () => {
        let seconds = Math.floor(this.state.video.currentTime % 60);
        let minutes = Math.floor(this.state.video.currentTime / 60);
        seconds = seconds >= 10 ? seconds : '0' + seconds;
        this.state.timeCounter.innerText = `${minutes}:${seconds} / ${this.state.timeTotal}`;
        if (this.state.isMouseDown) return;
        let percent = this.state.video.currentTime / this.state.video.duration * 100;
        let width = percent.toFixed(2)
        this.setState({ timeBarValue: this.state.video.currentTime, videoWidth: width });
    }

    eListener = (e) => {
        if ((!this.state.speedRef.current || this.state.speedRef.current.contains(e.target))
            || (!this.state.subSettingsRef.current || this.state.subSettingsRef.current.contains(e.target))
        ) {
            return;
        }
        this.closeAllDd();
    }

    initElements = () => {
        const controls = document.querySelector('.videoplayer-controls');
        const video = document.getElementById("videoplayer-id");
        const timeBar = document.querySelector('.videoplayer-timebar');
        const timeCounter = document.querySelector('time');

        this.setState({ video, timeBar, timeCounter, controls }, () => {
            this.state.video.playbackRate = this.state.currentSpeed;
            this.setDefaultVolume();
            this.checkAndLoadSrt();
        });
        video.addEventListener('loadedmetadata', this.setVideoData);
        video.addEventListener('timeupdate', this.updateCurrentTime);
        video.addEventListener('mousemove', () => { this.showUI(); this.hideUI() });

        //AUTO AND LOOP BEGIN 
        video.addEventListener('loadeddata', () => {
            const { isAutoPlay, isTrailer } = this.props;
            if (isAutoPlay && isTrailer) {
                console.log("LOGS: VIDEO LOADED");
                setTimeout(() => {
                    this.props.setPlayerDefault()
                }, 500);
            }
        });

        video.addEventListener('ended', () => {
            const { viewMode } = this.props.mediaObjects;
            if (viewMode && viewMode === ConfigTypes.HOME) {
                this.props.updateMediaObjects({ trailerWaiting: true });
                setTimeout(() => {
                    if (this.props.mediaObjects.trailerWaiting) {
                        this.loopLaneTrainer();
                    }
                    this.props.updateMediaObjects({ trailerWaiting: false });
                }, ConfigTypes.TRAILER_STARTTIME);
            }
        });
        //AUTO AND LOOP END

        if (video) this.getPlayerOffset(video);

        document.addEventListener("mousedown", this.eListener);
        document.addEventListener("touchstart", this.eListener);
    }

    initAll = () => {
        const { currentClip, hasMediaRights } = this.props.mediaObjects;
        if (currentClip) {
            let thumbUrl = this.getCurrentThumbUrl();
            let mediaUrl = this.getCurrentUrl();
            if (this.state.loadLater) {
                let disabled = '';
                if (!hasMediaRights) disabled = 'videoplayer-disable';
                this.setState({ thumbUrl: thumbUrl, disabled });
                if (this.state.isElemInit) {
                    this.setState({ mediaUrl: mediaUrl });
                    this.initElements();
                }
            } else {
                this.setState({ mediaUrl: mediaUrl, thumbUrl: thumbUrl });
                this.initElements();
            }
            this.props.updateMediaObjects({ openVideoPlayer: true });
        }
    }

    getElScreenOffset = (el) => {
        let rect = el.getBoundingClientRect();
        return rect.bottom;
    }

    getPlayerOffset = (el) => {
        if (el) {
            this.props.updateMediaObjects({ playerOffset: this.getElScreenOffset(el) });
            window.onscroll = () => {
                let offset = this.getElScreenOffset(el);
                if (offset != this.props.mediaObjects.playerOffset) {
                    this.props.updateMediaObjects({ playerOffset: offset });
                }
            }
        }
    }

    onTimeBarChange = (e) => {
        this.state.video.currentTime = e.target.value;
        this.setState({ timeBar: e.target.value });
        let percent = +e.target.value * 100 / this.state.video.duration;
        let width = percent.toFixed(2)
        this.setState({ timeBarValue: e.target.value, videoWidth: width });
    }

    onVolumeChange = (e) => {
        let volume = +e.target.value / 100;
        this.state.video.volume = volume;
        let volumeWidth = volume * 100;
        this.setState({ volumeWidth: volumeWidth });
    }

    togglePlayPause = () => {
        if (this.state.isPlaying) {
            this.setState({ isPlaying: false });
            this.state.video.pause();
        } else {
            this.setState({ isPlaying: true });
            this.state.video.play();
        }
    };

    checkAndPlay = () => {
        if (!this.state.isElemInit) {
            this.props.updateMediaObjects({ videoLoading: true });
            this.setState({ isElemInit: true, loading: true }, () => {
                this.setState({ loading: false });
                setTimeout(() => {
                    this.props.updateMediaObjects({ videoLoading: false });
                    this.setState({ isPlaying: true });
                    this.state.video.play();
                }, ConfigTypes.START_LOAD);
            });
        } else {
            this.togglePlayPause();
        }
    }

    onPlayBtnClick = () => {
        if (this.state.loadLater) {
            this.checkAndPlay();
        } else {
            this.togglePlayPause();
        }
    }

    setDefaultVolume = () => {
        if (this.state.video) {
            this.state.video.volume = ConfigTypes.VOLUME_DEFAULT;
        }
    }

    activateMuted = () => {
        this.state.video.muted = true;
        this.setState({ isMuted: true, volumeWidth: 0 });
    }

    deactivateMuted = () => {
        this.state.video.muted = false;
        this.setState({ isMuted: false, volumeWidth: ConfigTypes.VOLUME_WIDTH }, () => {
            this.setDefaultVolume();
        });
    }

    toggleMuted = () => {
        if (this.state.isMuted) {
            this.deactivateMuted();
        } else {
            this.activateMuted();
        }
    }

    onFullScreen = () => {
        const player = document.querySelector('.videoplayer-box');
        if (!this.state.isFullScreen) {
            if (player.requestFullscreen) {
                player.requestFullscreen();
            } else if (player.webkitRequestFullscreen) { /* Safari */
                player.webkitRequestFullscreen();
            } else if (player.msRequestFullscreen) { /* IE11 */
                player.msRequestFullscreen();
            }
            this.setState({ isFullScreen: true });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
                document.msExitFullscreen();
            }
            this.setState({ isFullScreen: false });
        }
    }

    getCurrentUrl = () => {
        let elements = null;
        let mediaUrl = "";
        const { currentClip } = this.props.mediaObjects;
        if (currentClip && currentClip.mediafiles && currentClip.mediafiles.elements) {
            elements = currentClip.mediafiles.elements;
            mediaUrl = getMediaUrl(elements, currentClip, ConfigTypes.VIDEO);
        }
        if (!mediaUrl) mediaUrl = `${pubPath()}/test.mp4`;
        if (currentClip.videourl) mediaUrl = currentClip.videourl;
        console.log("LOGS: VIDEOPLAYER mediaUrl", mediaUrl)
        return mediaUrl;
    }

    getCurrentThumbUrl = () => {
        let thumbUrl = "";
        const { currentClip } = this.props.mediaObjects;
        if (currentClip.mainthumbnail && currentClip.mainthumbnail.url) {
            thumbUrl = `https:${currentClip.mainthumbnail.url}`
            thumbUrl += `&width=${ConfigTypes.IMG_WIDTH}&height=${ConfigTypes.IMG_HEIGHT}`;
        }
        if (currentClip.thumbnail) {
            thumbUrl = currentClip.thumbnail;
        }
        return thumbUrl;
    }

    closeAllDd = (current = false) => {
        for (let i in this.state) {
            if (i.includes("DdDisplay") && this.state[i] === ConfigTypes.BLOCK) {
                if (!current || (current && !i.includes(`${current}DdDisplay`))) {
                    this.setState({ [i]: ConfigTypes.NONE });
                }
            }
        }
    }

    // SPEED BEGIN
    setCurrentSpeedItem = (item) => () => {
        this.state.video.playbackRate = parseFloat(item.option);
        this.setState({ speedDdDisplay: ConfigTypes.NONE, currentSpeed: item.option });
    }

    toggleSpeedList = (name) => () => {
        this.closeAllDd(name);
        if (this.state.speedDdDisplay === ConfigTypes.BLOCK) {
            this.setState({ speedDdDisplay: ConfigTypes.NONE });
        } else {
            this.setState({ speedDdDisplay: ConfigTypes.BLOCK });
        }
    }
    // SPEED END

    //SUBTITLE BEGIN

    checkAndLoadSrt = () => {
        if (ConfigTypes.SRT_SUBTITLE_TEST) {
            //this.state.video.removeEventListener('canplay', checkAndConvert(this.state.subLg));
            this.state.video.addEventListener('canplay', checkAndConvert(this.state.subLg));
        }
    }

    setSubLanguage = (subLg) => () => {
        this.setState({ subLg: subLg }, () => {
            this.setUpTracks({ isSubtitle: this.state.isSubtitle });
            this.checkAndLoadSrt();
        });
    }

    switchOnOffSubtitle = () => {
        const { currentClip } = this.props.mediaObjects;
        console.log("LOGS: currentClip", currentClip);
        if (currentClip.metadata && currentClip.metadata.fields
            && currentClip.metadata.fields.subtile) {
            this.setState({ isSubtitle: true });
        }
    }

    showVideoTrack = () => {
        let subtitles = ConfigTypes.SUBTITLES;
        if (ConfigTypes.SRT_SUBTITLE_TEST) subtitles = ConfigTypes.SUBTITLES_SRT;
        return (
            <React.Fragment>
                {subtitles
                    .map((item, i) => (
                        <track key={`videoplayer_track${i}`} kind="subtitles" src={`${pubPath()}/${item.src}`}
                            srcLang={item.name} label={item.label} />))}
            </React.Fragment>
        )
    }

    onCueChangeHandler = (e) => {
        let subElement = document.querySelector(".videoplayer-subtitles-text");
        let cue = this.state.track.activeCues[0];
        if (cue) {
            subElement.innerHTML = '';
            subElement.appendChild(cue.getCueAsHTML());
        }
    }
    setUpTracks = ({ isSubtitle }) => {
        let subElement = document.querySelector(".videoplayer-subtitles-text");
        if (subElement) subElement.innerHTML = '';
        if (this.state.stack) this.state.track.removeEventListener("cuechange", this.onCueChangeHandler);
        let subShow = isSubtitle ? ConfigTypes.BLOCK : ConfigTypes.NONE;
        this.setState({ subElement: subElement, subShow });
        for (let i = 0; i < this.state.video.textTracks.length; i++) {
            let track = this.state.video.textTracks[i];
            track.mode = ConfigTypes.HIDDEN;
            if (track.language == this.state.subLg && isSubtitle) {
                //track.mode = ConfigTypes.SHOWING;
                this.setState({ track: track }, () => {
                    track.addEventListener("cuechange", this.onCueChangeHandler);
                });
            }
        }
    }

    toggleOnOff = () => {
        if (ConfigTypes.SHOW_SUBTILE) {
            let subShow = ConfigTypes.NONE;
            if (!this.state.isSubtitle) subShow = ConfigTypes.BLOCK;
            this.setState({ isSubtitle: !this.state.isSubtitle, subShow });
            this.setUpTracks({ isSubtitle: !this.state.isSubtitle });
        }
    }

    toggleSubSettings = (name) => () => {
        this.closeAllDd(name);
        if (this.state.subSettingsDdDisplay === ConfigTypes.BLOCK) {
            this.setState({ subSettingsDdDisplay: ConfigTypes.NONE });
        }
        else this.setState({ subSettingsDdDisplay: ConfigTypes.BLOCK });
    }

    showSubtitleMenu = () => {
        if (ConfigTypes.SUBTITLE_TEST && !this.state.subLoading) {
            return (
                <div className="videoplayer-subtitles" ref={this.state.subSettingsRef}
                    onClick={this.toggleSubSettings("subSettings")}>
                    <img className="videoplayer-isubtitle" src={`${pubPath()}/subtitles_white.png`} alt="subtitle image" />
                    <div className="videoplayer-subtitles-settings" style={{ display: this.state.subSettingsDdDisplay }}>
                        {ConfigTypes.SUBTITLES
                            .map((item, i) => (
                                <span key={`videoplayer_subtitle${i}`} onClick={this.setSubLanguage(item.name)}
                                    style={{ color: this.state.subLg === item.name && this.state.isSubtitle ? 'red' : 'white' }}>
                                    {this.props.intl.formatMessage({ id: item.intl })}
                                </span>))}
                        <span onClick={this.toggleOnOff}>
                            {this.state.isSubtitle
                                ? this.props.intl.formatMessage({ id: "videoplayer.subtitle.off" })
                                : this.props.intl.formatMessage({ id: "videoplayer.subtitle.on" })}
                        </span>
                    </div>
                    <div className={this.state.isSubtitle ? "videoplayer-subitles-on" : "videoplayer-subitles-off"}>
                    </div>
                </div>)
        }

        return <div></div>
    }
    //SUBTITLE END

    updateVideo = () => {
        if (this.state.video) {
            this.state.video.pause();
            let mediaUrl = this.getCurrentUrl();
            this.state.video.src = mediaUrl;
            this.setDefaultVolume();
            let thumbUrl = this.getCurrentThumbUrl();
            this.setState({
                mediaUrl: mediaUrl,
                thumbUrl: thumbUrl,
                isPlaying: false,
                subLoading: true,
                volumeWidth: ConfigTypes.VOLUME_WIDTH,
            }, () => {
                this.setState({ subLoading: false });
            });
            this.getPlayerOffset(this.state.video);
            this.setUpTracks({ isSubtitle: this.state.isSubtitle });
            this.checkAndLoadSrt();
        }
    }

    componentDidUpdate(prev) {
        const { currentClip, videoLoading } = this.props.mediaObjects;
        if (!prev.mediaObjects.showVideo && this.props.mediaObjects.showVideo) {
            this.props.updateMediaObjects({ showAudio: false });
        }
        if ((!prev.mediaObjects.currentClip && currentClip) ||
            (currentClip && prev.mediaObjects.currentClip != currentClip)
        ) {
            if (this.state.loadLater) {
                this.setState({ isElemInit: false, loading: true }, () => {
                    this.initAll();
                    this.setState({ loading: false });
                });
            }
            else this.updateVideo();
        }

        if (this.state.loadLater && prev.mediaObjects.videoLoading && !videoLoading) {
            this.initAll();
        }
    }

    componentDidMount = () => {
        this.props.updateMediaObjects({ showVideo: true });
        this.initAll();
    }

    componentWilUnmount = () => {
        this.props.updateMediaObjects({ openVideoPlayer: false });
    }

    render() {
        if (!this.state.loading)
            return (
                <div className="VideoPlayer">
                    <div className='videoplayer-box'>
                        <div className="videoplayer-wrapper">
                            <video id="videoplayer-id" className="video-screen"
                                src={this.state.mediaUrl} tabIndex="0"
                                type='video/mp4' poster={this.state.thumbUrl}
                                msallowfullscreen webkitallowfullscreen mozallowfullscreen allowfullscreen>
                                {this.showVideoTrack()}
                            </video>
                            <div className="videoplayer-subtitles-text" style={{ display: this.state.subShow }} />
                        </div>
                        <div className={`videoplayer-controls active ${this.state.disabled}`}>
                            <div className="videoplayer-iplay" id="videoplayer-iplay-id" onClick={this.onPlayBtnClick}
                                onKeyUp={this.onPlayKeyUp} tabIndex="0" role="button" aria-label="play" >
                                <FontAwesomeIcon icon={this.state.isPlaying ? faPause : faPlay} />
                            </div>
                            <time className='videoplayer-time'>{this.state.loadLater ? '00:00' : 'N/A'}</time>
                            <div className="videoplayer-progress-box">
                                <div className="videoplayer-progress" style={{ width: `${this.state.videoWidth}%` }}></div>
                                <input type="range" className='videoplayer-timebar' onChange={this.onTimeBarChange}
                                    value={this.state.timeBarValue} min='0' max='100' aria-label="Seek slider" />
                            </div>
                            <input type="range" className='videoplayer-volumebar' min="1" max="100"
                                onChange={this.onVolumeChange} value={this.state.volumeWidth} aria-label="Adjust volume" />
                            <div className="videoplayer-ivolume-muted" onClick={this.toggleMuted}
                                onKeyUp={this.onMutedKeyUp} tabIndex="0" role="button" aria-label="Mute volume">
                                <FontAwesomeIcon icon={this.state.isMuted ? faVolumeMute : faVolumeUp} />
                            </div>
                            <div className="videoplayer-speed" onClick={this.toggleSpeedList("speed")} ref={this.state.speedRef}>
                                <div className="videoplayer-speed-list" style={{ display: this.state.speedDdDisplay }}>
                                    {ConfigTypes.VIDEO_SPEED.map((item, i) => (
                                        <div name={item.option} className="videoplayer-speed-item"
                                            style={{ color: this.state.currentSpeed === item.option ? 'red' : 'white' }}
                                            onClick={this.setCurrentSpeedItem(item)} key={`videoplayer_main${i}`} >
                                            {item.option}
                                        </div>))}
                                </div>
                                <div className="videoplayer-speed-current">{this.state.currentSpeed}</div>
                            </div>
                            {this.showSubtitleMenu()}
                            <div className="videoplayer-fullscreen-box" onClick={this.onFullScreen}
                                tabIndex="0" onKeyUp={this.onFullScreenKeyUp} role="button" aria-label="Full Screen">
                                <div className='videoplayer-fullscreen'></div>
                            </div>
                        </div>
                    </div>
                </div>
            );
    }
}

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    appObjects: state.app.appObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(VideoPlayer)));